/**
 * Do not edit directly
 * Generated on Fri, 01 Jul 2022 19:20:40 GMT
 */

module.exports = {
  'theme-colors': {
    outside: {
      primary: {
        yellow: {
          value: '#FFD204',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#FFD204',
            type: 'color'
          },
          name: 'ThemeColorsOutsidePrimaryYellow',
          attributes: {
            category: 'theme-colors',
            type: 'outside',
            item: 'primary',
            subitem: 'yellow'
          },
          path: ['theme-colors', 'outside', 'primary', 'yellow']
        },
        red: {
          value: '#E61E2C',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#E61E2C',
            type: 'color'
          },
          name: 'ThemeColorsOutsidePrimaryRed',
          attributes: {
            category: 'theme-colors',
            type: 'outside',
            item: 'primary',
            subitem: 'red'
          },
          path: ['theme-colors', 'outside', 'primary', 'red']
        },
        'red-hard': {
          value: '#9B1E25',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#9B1E25',
            type: 'color'
          },
          name: 'ThemeColorsOutsidePrimaryRedHard',
          attributes: {
            category: 'theme-colors',
            type: 'outside',
            item: 'primary',
            subitem: 'red-hard'
          },
          path: ['theme-colors', 'outside', 'primary', 'red-hard']
        },
        'blue-dark': {
          value: '#465871',
          description: '',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#465871',
            description: '',
            type: 'color'
          },
          name: 'ThemeColorsOutsidePrimaryBlueDark',
          attributes: {
            category: 'theme-colors',
            type: 'outside',
            item: 'primary',
            subitem: 'blue-dark'
          },
          path: ['theme-colors', 'outside', 'primary', 'blue-dark']
        }
      },
      secondary: {
        blue: {
          value: '#4996D7',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#4996D7',
            type: 'color'
          },
          name: 'ThemeColorsOutsideSecondaryBlue',
          attributes: {
            category: 'theme-colors',
            type: 'outside',
            item: 'secondary',
            subitem: 'blue'
          },
          path: ['theme-colors', 'outside', 'secondary', 'blue']
        },
        green: {
          value: '#9AB506',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#9AB506',
            type: 'color'
          },
          name: 'ThemeColorsOutsideSecondaryGreen',
          attributes: {
            category: 'theme-colors',
            type: 'outside',
            item: 'secondary',
            subitem: 'green'
          },
          path: ['theme-colors', 'outside', 'secondary', 'green']
        }
      },
      tertiary: {
        'blue-medium': {
          value: '#006699',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#006699',
            type: 'color'
          },
          name: 'ThemeColorsOutsideTertiaryBlueMedium',
          attributes: {
            category: 'theme-colors',
            type: 'outside',
            item: 'tertiary',
            subitem: 'blue-medium'
          },
          path: ['theme-colors', 'outside', 'tertiary', 'blue-medium']
        }
      },
      variables: {
        'default-bgs': {
          'block-dark': {
            value: {
              value: '#000000',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#000000',
                type: 'color'
              },
              name: 'ColorsPrimaryBlack',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black'
              },
              path: ['colors', 'primary', 'black']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesDefaultBgsBlockDark',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'default-bgs',
              state: 'block-dark'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'default-bgs',
              'block-dark'
            ]
          },
          'block-light': {
            value: {
              value: '#FFD204',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFD204',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outside', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesDefaultBgsBlockLight',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'default-bgs',
              state: 'block-light'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'default-bgs',
              'block-light'
            ]
          }
        },
        'default-colors': {
          heading: {
            value: {
              value: '#FFD204',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFD204',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outside', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesDefaultColorsHeading',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'default-colors',
              state: 'heading'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'default-colors',
              'heading'
            ]
          },
          'paragraph-copy': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesDefaultColorsParagraphCopy',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'default-colors',
              state: 'paragraph-copy'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'default-colors',
              'paragraph-copy'
            ]
          },
          alert: {
            value: {
              value: '#E61E2C',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#E61E2C',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryRed',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'red'
              },
              path: ['theme-colors', 'outside', 'primary', 'red']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.red}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesDefaultColorsAlert',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'default-colors',
              state: 'alert'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'default-colors',
              'alert'
            ]
          },
          success: {
            value: {
              value: '#9AB506',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#9AB506',
                type: 'color'
              },
              name: 'ThemeColorsOutsideSecondaryGreen',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'secondary',
                subitem: 'green'
              },
              path: ['theme-colors', 'outside', 'secondary', 'green']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.secondary.green}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesDefaultColorsSuccess',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'default-colors',
              state: 'success'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'default-colors',
              'success'
            ]
          },
          'accent-border': {
            value: {
              value: '#FFD204',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFD204',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outside', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesDefaultColorsAccentBorder',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'default-colors',
              state: 'accent-border'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'default-colors',
              'accent-border'
            ]
          },
          link: {
            value: {
              value: '#9B1E25',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#9B1E25',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryRedHard',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'red-hard'
              },
              path: ['theme-colors', 'outside', 'primary', 'red-hard']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.red-hard}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesDefaultColorsLink',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'default-colors',
              state: 'link'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'default-colors',
              'link'
            ]
          },
          'link--hover': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesDefaultColorsLinkHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'default-colors',
              state: 'link--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'default-colors',
              'link--hover'
            ]
          },
          'link-border--hover': {
            value: {
              value: '#FFD204',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFD204',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outside', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesDefaultColorsLinkBorderHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'default-colors',
              state: 'link-border--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'default-colors',
              'link-border--hover'
            ]
          },
          'icon-color': {
            value: {
              value: '#000000',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#000000',
                type: 'color'
              },
              name: 'ColorsPrimaryBlack',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black'
              },
              path: ['colors', 'primary', 'black']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesDefaultColorsIconColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'default-colors',
              state: 'icon-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'default-colors',
              'icon-color'
            ]
          },
          'icon-color--hover': {
            value: {
              value: '#FFD204',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFD204',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outside', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesDefaultColorsIconColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'default-colors',
              state: 'icon-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'default-colors',
              'icon-color--hover'
            ]
          }
        },
        'overlay-nav': {
          bg: {
            value: {
              value: '#FFD204',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFD204',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outside', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesOverlayNavBg',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'overlay-nav',
              state: 'bg'
            },
            path: ['theme-colors', 'outside', 'variables', 'overlay-nav', 'bg']
          },
          color: {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesOverlayNavColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'overlay-nav',
              state: 'color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'overlay-nav',
              'color'
            ]
          },
          'link-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesOverlayNavLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'overlay-nav',
              state: 'link-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'overlay-nav',
              'link-color'
            ]
          },
          'link--hover': {
            value: {
              value: '#465871',
              description: '',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#465871',
                description: '',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryBlueDark',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'blue-dark'
              },
              path: ['theme-colors', 'outside', 'primary', 'blue-dark']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.blue-dark}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesOverlayNavLinkHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'overlay-nav',
              state: 'link--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'overlay-nav',
              'link--hover'
            ]
          }
        },
        'primary-nav': {
          bg: {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavBg',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'bg'
            },
            path: ['theme-colors', 'outside', 'variables', 'primary-nav', 'bg']
          },
          'link-color': {
            value: {
              value: '#000000',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#000000',
                type: 'color'
              },
              name: 'ColorsPrimaryBlack',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black'
              },
              path: ['colors', 'primary', 'black']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'link-color'
            ]
          },
          'link-border-color': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavLinkBorderColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-border-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'link-border-color'
            ]
          },
          'link-color--hover': {
            value: {
              value: '#9B1E25',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#9B1E25',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryRedHard',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'red-hard'
              },
              path: ['theme-colors', 'outside', 'primary', 'red-hard']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.red-hard}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'link-color--hover'
            ]
          },
          'link-border-color--hover': {
            value: {
              value: '#FFD204',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFD204',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outside', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavLinkBorderColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-border-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'link-border-color--hover'
            ]
          },
          'link-bg--hover': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavLinkBgHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-bg--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'link-bg--hover'
            ]
          },
          'link-color--active': {
            value: {
              value: '#9B1E25',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#9B1E25',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryRedHard',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'red-hard'
              },
              path: ['theme-colors', 'outside', 'primary', 'red-hard']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.red-hard}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavLinkColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-color--active'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'link-color--active'
            ]
          },
          'link-border-color--active': {
            value: {
              value: '#FFD204',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFD204',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outside', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavLinkBorderColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-border-color--active'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'link-border-color--active'
            ]
          },
          'link-bg--active': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavLinkBgActive',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-bg--active'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'link-bg--active'
            ]
          },
          'dropdown-bg': {
            value: {
              value: '#ffffff',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#ffffff',
                type: 'color'
              },
              name: 'ColorsPrimaryWhite',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'white'
              },
              path: ['colors', 'primary', 'white']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.white}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavDropdownBg',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-bg'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'dropdown-bg'
            ]
          },
          'dropdown-link-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavDropdownLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'dropdown-link-color'
            ]
          },
          'dropdown-link-border-color': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavDropdownLinkBorderColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-border-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'dropdown-link-border-color'
            ]
          },
          'dropdown-link-color--hover': {
            value: {
              value: '#9B1E25',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#9B1E25',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryRedHard',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'red-hard'
              },
              path: ['theme-colors', 'outside', 'primary', 'red-hard']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.red-hard}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavDropdownLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'dropdown-link-color--hover'
            ]
          },
          'dropdown-link-border-color--hover': {
            value: {
              value: '#FFD204',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFD204',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outside', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavDropdownLinkBorderColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-border-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'dropdown-link-border-color--hover'
            ]
          },
          'dropdown-link-bg--hover': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavDropdownLinkBgHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-bg--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'dropdown-link-bg--hover'
            ]
          },
          'dropdown-link-color--active': {
            value: {
              value: '#9B1E25',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#9B1E25',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryRedHard',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'red-hard'
              },
              path: ['theme-colors', 'outside', 'primary', 'red-hard']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.red-hard}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavDropdownLinkColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-color--active'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'dropdown-link-color--active'
            ]
          },
          'dropdown-link-border-color--active': {
            value: {
              value: '#FFD204',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFD204',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outside', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavDropdownLinkBorderColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-border-color--active'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'dropdown-link-border-color--active'
            ]
          },
          'dropdown-link-bg--active': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesPrimaryNavDropdownLinkBgActive',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-bg--active'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'primary-nav',
              'dropdown-link-bg--active'
            ]
          }
        },
        'secondary-nav': {
          bg: {
            value: {
              value: '#ededed',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#ededed',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyLight',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-light'
              },
              path: ['colors', 'neutrals', 'grey-light']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-light}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavBg',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'bg'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'bg'
            ]
          },
          'link-color': {
            value: {
              value: '#000000',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#000000',
                type: 'color'
              },
              name: 'ColorsPrimaryBlack',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black'
              },
              path: ['colors', 'primary', 'black']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'link-color'
            ]
          },
          'link-border-color': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavLinkBorderColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-border-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'link-border-color'
            ]
          },
          'link-color--hover': {
            value: {
              value: '#9B1E25',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#9B1E25',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryRedHard',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'red-hard'
              },
              path: ['theme-colors', 'outside', 'primary', 'red-hard']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.red-hard}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'link-color--hover'
            ]
          },
          'link-border-color--hover': {
            value: {
              value: '#FFD204',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFD204',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outside', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavLinkBorderColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-border-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'link-border-color--hover'
            ]
          },
          'link-bg--hover': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavLinkBgHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-bg--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'link-bg--hover'
            ]
          },
          'link-color--active': {
            value: {
              value: '#9B1E25',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#9B1E25',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryRedHard',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'red-hard'
              },
              path: ['theme-colors', 'outside', 'primary', 'red-hard']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.red-hard}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavLinkColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-color--active'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'link-color--active'
            ]
          },
          'link-border-color--active': {
            value: {
              value: '#FFD204',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFD204',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outside', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavLinkBorderColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-border-color--active'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'link-border-color--active'
            ]
          },
          'link-bg--active': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavLinkBgActive',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-bg--active'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'link-bg--active'
            ]
          },
          'dropdown-bg': {
            value: {
              value: '#ffffff',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#ffffff',
                type: 'color'
              },
              name: 'ColorsPrimaryWhite',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'white'
              },
              path: ['colors', 'primary', 'white']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.white}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavDropdownBg',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-bg'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'dropdown-bg'
            ]
          },
          'dropdown-link-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavDropdownLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'dropdown-link-color'
            ]
          },
          'dropdown-link-border-color': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavDropdownLinkBorderColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-border-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'dropdown-link-border-color'
            ]
          },
          'dropdown-link-color--hover': {
            value: {
              value: '#9B1E25',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#9B1E25',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryRedHard',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'red-hard'
              },
              path: ['theme-colors', 'outside', 'primary', 'red-hard']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.red-hard}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavDropdownLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'dropdown-link-color--hover'
            ]
          },
          'dropdown-link-border-color--hover': {
            value: {
              value: '#FFD204',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFD204',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outside', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavDropdownLinkBorderColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-border-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'dropdown-link-border-color--hover'
            ]
          },
          'dropdown-link-bg--hover': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavDropdownLinkBgHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-bg--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'dropdown-link-bg--hover'
            ]
          },
          'dropdown-link-color--active': {
            value: {
              value: '#9B1E25',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#9B1E25',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryRedHard',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'red-hard'
              },
              path: ['theme-colors', 'outside', 'primary', 'red-hard']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.red-hard}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavDropdownLinkColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-color--active'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'dropdown-link-color--active'
            ]
          },
          'dropdown-link-border-color--active': {
            value: {
              value: '#FFD204',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFD204',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outside', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavDropdownLinkBorderColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-border-color--active'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'dropdown-link-border-color--active'
            ]
          },
          'dropdown-link-bg--active': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesSecondaryNavDropdownLinkBgActive',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-bg--active'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'secondary-nav',
              'dropdown-link-bg--active'
            ]
          }
        },
        tags: {
          'link-color': {
            value: {
              value: '#7e8489',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#7e8489',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyDarker',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-darker'
              },
              path: ['colors', 'neutrals', 'grey-darker']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-darker}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesTagsLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'tags',
              state: 'link-color'
            },
            path: ['theme-colors', 'outside', 'variables', 'tags', 'link-color']
          },
          'link-color--hover': {
            value: {
              value: '#000000',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#000000',
                type: 'color'
              },
              name: 'ColorsPrimaryBlack',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black'
              },
              path: ['colors', 'primary', 'black']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesTagsLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'tags',
              state: 'link-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'tags',
              'link-color--hover'
            ]
          }
        },
        articles: {
          'headline-link-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesArticlesHeadlineLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'articles',
              state: 'headline-link-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'articles',
              'headline-link-color'
            ]
          },
          'kicker-link-color': {
            value: {
              value: '#7e8489',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#7e8489',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyDarker',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-darker'
              },
              path: ['colors', 'neutrals', 'grey-darker']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-darker}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesArticlesKickerLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'articles',
              state: 'kicker-link-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'articles',
              'kicker-link-color'
            ]
          },
          'post-meta-link-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesArticlesPostMetaLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'articles',
              state: 'post-meta-link-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'articles',
              'post-meta-link-color'
            ]
          },
          'postmeta-datetime-color': {
            value: {
              value: '#7e8489',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#7e8489',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyDarker',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-darker'
              },
              path: ['colors', 'neutrals', 'grey-darker']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-darker}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesArticlesPostmetaDatetimeColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'articles',
              state: 'postmeta-datetime-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'articles',
              'postmeta-datetime-color'
            ]
          },
          'deck-color': {
            value: {
              value: '#465871',
              description: '',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#465871',
                description: '',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryBlueDark',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'blue-dark'
              },
              path: ['theme-colors', 'outside', 'primary', 'blue-dark']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.blue-dark}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesArticlesDeckColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'articles',
              state: 'deck-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'articles',
              'deck-color'
            ]
          },
          'headline-link-color--hover': {
            value: {
              value: '#9B1E25',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#9B1E25',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryRedHard',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'red-hard'
              },
              path: ['theme-colors', 'outside', 'primary', 'red-hard']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.red-hard}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesArticlesHeadlineLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'articles',
              state: 'headline-link-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'articles',
              'headline-link-color--hover'
            ]
          },
          'kicker-link-color--hover': {
            value: {
              value: '#9B1E25',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#9B1E25',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryRedHard',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'red-hard'
              },
              path: ['theme-colors', 'outside', 'primary', 'red-hard']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.red-hard}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesArticlesKickerLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'articles',
              state: 'kicker-link-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'articles',
              'kicker-link-color--hover'
            ]
          },
          'postmeta-link-color--hover': {
            value: {
              value: '#9B1E25',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#9B1E25',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryRedHard',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'red-hard'
              },
              path: ['theme-colors', 'outside', 'primary', 'red-hard']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.red-hard}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesArticlesPostmetaLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'articles',
              state: 'postmeta-link-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'articles',
              'postmeta-link-color--hover'
            ]
          }
        },
        'form-components': {
          'value-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesFormComponentsValueColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'form-components',
              state: 'value-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'form-components',
              'value-color'
            ]
          },
          'label-color': {
            value: {
              value: '#7e8489',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#7e8489',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyDarker',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-darker'
              },
              path: ['colors', 'neutrals', 'grey-darker']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-darker}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesFormComponentsLabelColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'form-components',
              state: 'label-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'form-components',
              'label-color'
            ]
          },
          bg: {
            value: {
              value: '#ffffff',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#ffffff',
                type: 'color'
              },
              name: 'ColorsPrimaryWhite',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'white'
              },
              path: ['colors', 'primary', 'white']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.white}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesFormComponentsBg',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'form-components',
              state: 'bg'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'form-components',
              'bg'
            ]
          },
          'border-color': {
            value: {
              value: '#ededed',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#ededed',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyLight',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-light'
              },
              path: ['colors', 'neutrals', 'grey-light']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-light}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesFormComponentsBorderColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'form-components',
              state: 'border-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'form-components',
              'border-color'
            ]
          },
          'label-color--focus': {
            value: {
              value: '#7e8489',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#7e8489',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyDarker',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-darker'
              },
              path: ['colors', 'neutrals', 'grey-darker']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-darker}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesFormComponentsLabelColorFocus',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'form-components',
              state: 'label-color--focus'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'form-components',
              'label-color--focus'
            ]
          },
          'bg--focus': {
            value: {
              value: '#f5f5f5',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#f5f5f5',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyPale',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-pale'
              },
              path: ['colors', 'neutrals', 'grey-pale']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-pale}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesFormComponentsBgFocus',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'form-components',
              state: 'bg--focus'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'form-components',
              'bg--focus'
            ]
          },
          'border-color--focus': {
            value: {
              value: '#b7babc',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#b7babc',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyDark',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-dark'
              },
              path: ['colors', 'neutrals', 'grey-dark']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-dark}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesFormComponentsBorderColorFocus',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'form-components',
              state: 'border-color--focus'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'form-components',
              'border-color--focus'
            ]
          }
        },
        buttons: {
          'primary-button-bg': {
            value: {
              value: '#000000',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#000000',
                type: 'color'
              },
              name: 'ColorsPrimaryBlack',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black'
              },
              path: ['colors', 'primary', 'black']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesButtonsPrimaryButtonBg',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'buttons',
              state: 'primary-button-bg'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'buttons',
              'primary-button-bg'
            ]
          },
          'primary-button-color': {
            value: {
              value: '#ffffff',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#ffffff',
                type: 'color'
              },
              name: 'ColorsPrimaryWhite',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'white'
              },
              path: ['colors', 'primary', 'white']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.white}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesButtonsPrimaryButtonColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'buttons',
              state: 'primary-button-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'buttons',
              'primary-button-color'
            ]
          },
          'primary-button-border-color': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesButtonsPrimaryButtonBorderColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'buttons',
              state: 'primary-button-border-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'buttons',
              'primary-button-border-color'
            ]
          },
          'primary-button-bg--hover': {
            value: {
              value: '#9B1E25',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#9B1E25',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryRedHard',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'red-hard'
              },
              path: ['theme-colors', 'outside', 'primary', 'red-hard']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.red-hard}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesButtonsPrimaryButtonBgHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'buttons',
              state: 'primary-button-bg--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'buttons',
              'primary-button-bg--hover'
            ]
          },
          'primary-button-color--hover': {
            value: {
              value: '#ffffff',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#ffffff',
                type: 'color'
              },
              name: 'ColorsPrimaryWhite',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'white'
              },
              path: ['colors', 'primary', 'white']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.white}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesButtonsPrimaryButtonColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'buttons',
              state: 'primary-button-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'buttons',
              'primary-button-color--hover'
            ]
          },
          'primary-button-border-color--hover': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesButtonsPrimaryButtonBorderColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'buttons',
              state: 'primary-button-border-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'buttons',
              'primary-button-border-color--hover'
            ]
          },
          'secondary-button-bg': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesButtonsSecondaryButtonBg',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'buttons',
              state: 'secondary-button-bg'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'buttons',
              'secondary-button-bg'
            ]
          },
          'secondary-button-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesButtonsSecondaryButtonColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'buttons',
              state: 'secondary-button-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'buttons',
              'secondary-button-color'
            ]
          },
          'secondary-button-border-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesButtonsSecondaryButtonBorderColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'buttons',
              state: 'secondary-button-border-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'buttons',
              'secondary-button-border-color'
            ]
          },
          'secondary-button-bg--hover': {
            value: {
              value: '#000000',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#000000',
                type: 'color'
              },
              name: 'ColorsPrimaryBlack',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black'
              },
              path: ['colors', 'primary', 'black']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesButtonsSecondaryButtonBgHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'buttons',
              state: 'secondary-button-bg--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'buttons',
              'secondary-button-bg--hover'
            ]
          },
          'secondary-button-color--hover': {
            value: {
              value: '#ffffff',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#ffffff',
                type: 'color'
              },
              name: 'ColorsPrimaryWhite',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'white'
              },
              path: ['colors', 'primary', 'white']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.white}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesButtonsSecondaryButtonColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'buttons',
              state: 'secondary-button-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'buttons',
              'secondary-button-color--hover'
            ]
          },
          'secondary-button-border-color--hover': {
            value: {
              value: '#000000',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#000000',
                type: 'color'
              },
              name: 'ColorsPrimaryBlack',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black'
              },
              path: ['colors', 'primary', 'black']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesButtonsSecondaryButtonBorderColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'buttons',
              state: 'secondary-button-border-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'buttons',
              'secondary-button-border-color--hover'
            ]
          }
        },
        topics: {
          'icon-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesTopicsIconColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'topics',
              state: 'icon-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'topics',
              'icon-color'
            ]
          },
          'link-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesTopicsLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'topics',
              state: 'link-color'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'topics',
              'link-color'
            ]
          },
          'link-color--hover': {
            value: {
              value: '#9B1E25',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#9B1E25',
                type: 'color'
              },
              name: 'ThemeColorsOutsidePrimaryRedHard',
              attributes: {
                category: 'theme-colors',
                type: 'outside',
                item: 'primary',
                subitem: 'red-hard'
              },
              path: ['theme-colors', 'outside', 'primary', 'red-hard']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outside.primary.red-hard}',
              type: 'color'
            },
            name: 'ThemeColorsOutsideVariablesTopicsLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outside',
              item: 'variables',
              subitem: 'topics',
              state: 'link-color--hover'
            },
            path: [
              'theme-colors',
              'outside',
              'variables',
              'topics',
              'link-color--hover'
            ]
          }
        }
      }
    }
  },
  'theme-fontFamilies': {
    outside: {
      fonts: {
        'font-1': {
          value: 'Guardian Egyp',
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: 'Guardian Egyp',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOutsideFontsFont1',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outside',
            item: 'fonts',
            subitem: 'font-1'
          },
          path: ['theme-fontFamilies', 'outside', 'fonts', 'font-1']
        },
        'font-2': {
          value: 'Helvetica Neue',
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: 'Helvetica Neue',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOutsideFontsFont2',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outside',
            item: 'fonts',
            subitem: 'font-2'
          },
          path: ['theme-fontFamilies', 'outside', 'fonts', 'font-2']
        }
      },
      variables: {
        'headline--font': {
          value: {
            value: 'Guardian Egyp',
            type: 'fontFamilies',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: 'Guardian Egyp',
              type: 'fontFamilies'
            },
            name: 'ThemeFontFamiliesOutsideFontsFont1',
            attributes: {
              category: 'theme-fontFamilies',
              type: 'outside',
              item: 'fonts',
              subitem: 'font-1'
            },
            path: ['theme-fontFamilies', 'outside', 'fonts', 'font-1']
          },
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{theme-fontFamilies.outside.fonts.font-1}',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOutsideVariablesHeadlineFont',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outside',
            item: 'variables',
            subitem: 'headline--font'
          },
          path: ['theme-fontFamilies', 'outside', 'variables', 'headline--font']
        },
        'headline-xl--font': {
          value: {
            value: 'Guardian Egyp',
            type: 'fontFamilies',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: 'Guardian Egyp',
              type: 'fontFamilies'
            },
            name: 'ThemeFontFamiliesOutsideFontsFont1',
            attributes: {
              category: 'theme-fontFamilies',
              type: 'outside',
              item: 'fonts',
              subitem: 'font-1'
            },
            path: ['theme-fontFamilies', 'outside', 'fonts', 'font-1']
          },
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{theme-fontFamilies.outside.fonts.font-1}',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOutsideVariablesHeadlineXlFont',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outside',
            item: 'variables',
            subitem: 'headline-xl--font'
          },
          path: [
            'theme-fontFamilies',
            'outside',
            'variables',
            'headline-xl--font'
          ]
        },
        'utility-text--font': {
          value: {
            value: 'Helvetica Neue',
            type: 'fontFamilies',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: 'Helvetica Neue',
              type: 'fontFamilies'
            },
            name: 'ThemeFontFamiliesOutsideFontsFont2',
            attributes: {
              category: 'theme-fontFamilies',
              type: 'outside',
              item: 'fonts',
              subitem: 'font-2'
            },
            path: ['theme-fontFamilies', 'outside', 'fonts', 'font-2']
          },
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{theme-fontFamilies.outside.fonts.font-2}',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOutsideVariablesUtilityTextFont',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outside',
            item: 'variables',
            subitem: 'utility-text--font'
          },
          path: [
            'theme-fontFamilies',
            'outside',
            'variables',
            'utility-text--font'
          ]
        },
        'utility-text--uppercase-xl--font': {
          value: {
            value: 'Helvetica Neue',
            type: 'fontFamilies',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: 'Helvetica Neue',
              type: 'fontFamilies'
            },
            name: 'ThemeFontFamiliesOutsideFontsFont2',
            attributes: {
              category: 'theme-fontFamilies',
              type: 'outside',
              item: 'fonts',
              subitem: 'font-2'
            },
            path: ['theme-fontFamilies', 'outside', 'fonts', 'font-2']
          },
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{theme-fontFamilies.outside.fonts.font-2}',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOutsideVariablesUtilityTextUppercaseXlFont',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outside',
            item: 'variables',
            subitem: 'utility-text--uppercase-xl--font'
          },
          path: [
            'theme-fontFamilies',
            'outside',
            'variables',
            'utility-text--uppercase-xl--font'
          ]
        },
        'paragraph-copy--font': {
          value: {
            value: 'Helvetica Neue',
            type: 'fontFamilies',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: 'Helvetica Neue',
              type: 'fontFamilies'
            },
            name: 'ThemeFontFamiliesOutsideFontsFont2',
            attributes: {
              category: 'theme-fontFamilies',
              type: 'outside',
              item: 'fonts',
              subitem: 'font-2'
            },
            path: ['theme-fontFamilies', 'outside', 'fonts', 'font-2']
          },
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{theme-fontFamilies.outside.fonts.font-2}',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOutsideVariablesParagraphCopyFont',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outside',
            item: 'variables',
            subitem: 'paragraph-copy--font'
          },
          path: [
            'theme-fontFamilies',
            'outside',
            'variables',
            'paragraph-copy--font'
          ]
        },
        'article-copy--font': {
          value: {
            value: 'Georgia',
            type: 'fontFamilies',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: 'Georgia',
              type: 'fontFamilies'
            },
            name: 'FontFamiliesFontsFont3',
            attributes: {
              category: 'fontFamilies',
              type: 'fonts',
              item: 'font-3'
            },
            path: ['fontFamilies', 'fonts', 'font-3']
          },
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontFamilies.fonts.font-3}',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOutsideVariablesArticleCopyFont',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outside',
            item: 'variables',
            subitem: 'article-copy--font'
          },
          path: [
            'theme-fontFamilies',
            'outside',
            'variables',
            'article-copy--font'
          ]
        }
      }
    }
  },
  'theme-fontWeights': {
    outside: {
      variables: {
        'headline--font-weight': {
          value: {
            value: '600',
            type: 'fontWeights',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: '600',
              type: 'fontWeights'
            },
            name: 'FontWeightsWeights600',
            attributes: {
              category: 'fontWeights',
              type: 'weights',
              item: '600'
            },
            path: ['fontWeights', 'weights', '600']
          },
          type: 'fontWeights',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontWeights.weights.600}',
            type: 'fontWeights'
          },
          name: 'ThemeFontWeightsOutsideVariablesHeadlineFontWeight',
          attributes: {
            category: 'theme-fontWeights',
            type: 'outside',
            item: 'variables',
            subitem: 'headline--font-weight'
          },
          path: [
            'theme-fontWeights',
            'outside',
            'variables',
            'headline--font-weight'
          ]
        },
        'headline-xl--font-weight': {
          value: {
            value: '600',
            type: 'fontWeights',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: '600',
              type: 'fontWeights'
            },
            name: 'FontWeightsWeights600',
            attributes: {
              category: 'fontWeights',
              type: 'weights',
              item: '600'
            },
            path: ['fontWeights', 'weights', '600']
          },
          type: 'fontWeights',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontWeights.weights.600}',
            type: 'fontWeights'
          },
          name: 'ThemeFontWeightsOutsideVariablesHeadlineXlFontWeight',
          attributes: {
            category: 'theme-fontWeights',
            type: 'outside',
            item: 'variables',
            subitem: 'headline-xl--font-weight'
          },
          path: [
            'theme-fontWeights',
            'outside',
            'variables',
            'headline-xl--font-weight'
          ]
        },
        'utility-text--font-weight': {
          value: {
            value: '400',
            type: 'fontWeights',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: '400',
              type: 'fontWeights'
            },
            name: 'FontWeightsWeights400',
            attributes: {
              category: 'fontWeights',
              type: 'weights',
              item: '400'
            },
            path: ['fontWeights', 'weights', '400']
          },
          type: 'fontWeights',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontWeights.weights.400}',
            type: 'fontWeights'
          },
          name: 'ThemeFontWeightsOutsideVariablesUtilityTextFontWeight',
          attributes: {
            category: 'theme-fontWeights',
            type: 'outside',
            item: 'variables',
            subitem: 'utility-text--font-weight'
          },
          path: [
            'theme-fontWeights',
            'outside',
            'variables',
            'utility-text--font-weight'
          ]
        },
        'utility-text--uppercase--font-weight': {
          value: {
            value: '700',
            type: 'fontWeights',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: '700',
              type: 'fontWeights'
            },
            name: 'FontWeightsWeights700',
            attributes: {
              category: 'fontWeights',
              type: 'weights',
              item: '700'
            },
            path: ['fontWeights', 'weights', '700']
          },
          type: 'fontWeights',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontWeights.weights.700}',
            type: 'fontWeights'
          },
          name: 'ThemeFontWeightsOutsideVariablesUtilityTextUppercaseFontWeight',
          attributes: {
            category: 'theme-fontWeights',
            type: 'outside',
            item: 'variables',
            subitem: 'utility-text--uppercase--font-weight'
          },
          path: [
            'theme-fontWeights',
            'outside',
            'variables',
            'utility-text--uppercase--font-weight'
          ]
        },
        'utility-text--uppercase-xl--font-weight': {
          value: {
            value: '400',
            type: 'fontWeights',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: '400',
              type: 'fontWeights'
            },
            name: 'FontWeightsWeights400',
            attributes: {
              category: 'fontWeights',
              type: 'weights',
              item: '400'
            },
            path: ['fontWeights', 'weights', '400']
          },
          type: 'fontWeights',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontWeights.weights.400}',
            type: 'fontWeights'
          },
          name: 'ThemeFontWeightsOutsideVariablesUtilityTextUppercaseXlFontWeight',
          attributes: {
            category: 'theme-fontWeights',
            type: 'outside',
            item: 'variables',
            subitem: 'utility-text--uppercase-xl--font-weight'
          },
          path: [
            'theme-fontWeights',
            'outside',
            'variables',
            'utility-text--uppercase-xl--font-weight'
          ]
        },
        'paragraph-copy--font-weight': {
          value: {
            value: '400',
            type: 'fontWeights',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: '400',
              type: 'fontWeights'
            },
            name: 'FontWeightsWeights400',
            attributes: {
              category: 'fontWeights',
              type: 'weights',
              item: '400'
            },
            path: ['fontWeights', 'weights', '400']
          },
          type: 'fontWeights',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontWeights.weights.400}',
            type: 'fontWeights'
          },
          name: 'ThemeFontWeightsOutsideVariablesParagraphCopyFontWeight',
          attributes: {
            category: 'theme-fontWeights',
            type: 'outside',
            item: 'variables',
            subitem: 'paragraph-copy--font-weight'
          },
          path: [
            'theme-fontWeights',
            'outside',
            'variables',
            'paragraph-copy--font-weight'
          ]
        },
        'article-copy--font-weight': {
          value: {
            value: '400',
            type: 'fontWeights',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: '400',
              type: 'fontWeights'
            },
            name: 'FontWeightsWeights400',
            attributes: {
              category: 'fontWeights',
              type: 'weights',
              item: '400'
            },
            path: ['fontWeights', 'weights', '400']
          },
          type: 'fontWeights',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontWeights.weights.400}',
            type: 'fontWeights'
          },
          name: 'ThemeFontWeightsOutsideVariablesArticleCopyFontWeight',
          attributes: {
            category: 'theme-fontWeights',
            type: 'outside',
            item: 'variables',
            subitem: 'article-copy--font-weight'
          },
          path: [
            'theme-fontWeights',
            'outside',
            'variables',
            'article-copy--font-weight'
          ]
        }
      }
    }
  },
  colors: {
    primary: {
      black: {
        value: '#000000',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#000000',
          type: 'color'
        },
        name: 'ColorsPrimaryBlack',
        attributes: {
          category: 'colors',
          type: 'primary',
          item: 'black'
        },
        path: ['colors', 'primary', 'black']
      },
      'black-soft': {
        value: '#333333',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#333333',
          type: 'color'
        },
        name: 'ColorsPrimaryBlackSoft',
        attributes: {
          category: 'colors',
          type: 'primary',
          item: 'black-soft'
        },
        path: ['colors', 'primary', 'black-soft']
      },
      white: {
        value: '#ffffff',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#ffffff',
          type: 'color'
        },
        name: 'ColorsPrimaryWhite',
        attributes: {
          category: 'colors',
          type: 'primary',
          item: 'white'
        },
        path: ['colors', 'primary', 'white']
      },
      'outside-yellow': {
        value: '#fdd20a',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#fdd20a',
          type: 'color'
        },
        name: 'ColorsPrimaryOutsideYellow',
        attributes: {
          category: 'colors',
          type: 'primary',
          item: 'outside-yellow'
        },
        path: ['colors', 'primary', 'outside-yellow']
      },
      'outside-red': {
        value: '#ea2127',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#ea2127',
          type: 'color'
        },
        name: 'ColorsPrimaryOutsideRed',
        attributes: {
          category: 'colors',
          type: 'primary',
          item: 'outside-red'
        },
        path: ['colors', 'primary', 'outside-red']
      },
      none: {
        value: 'rgba(0, 0, 0, 0)',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: 'rgba(0, 0, 0, 0)',
          type: 'color'
        },
        name: 'ColorsPrimaryNone',
        attributes: {
          category: 'colors',
          type: 'primary',
          item: 'none'
        },
        path: ['colors', 'primary', 'none']
      }
    },
    secondary: {
      gold: {
        value: '#d2a940',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#d2a940',
          type: 'color'
        },
        name: 'ColorsSecondaryGold',
        attributes: {
          category: 'colors',
          type: 'secondary',
          item: 'gold'
        },
        path: ['colors', 'secondary', 'gold']
      },
      'gold-light': {
        value: '#ebd882',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#ebd882',
          type: 'color'
        },
        name: 'ColorsSecondaryGoldLight',
        attributes: {
          category: 'colors',
          type: 'secondary',
          item: 'gold-light'
        },
        path: ['colors', 'secondary', 'gold-light']
      },
      'gold-pale': {
        value: '#faf5de',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#faf5de',
          type: 'color'
        },
        name: 'ColorsSecondaryGoldPale',
        attributes: {
          category: 'colors',
          type: 'secondary',
          item: 'gold-pale'
        },
        path: ['colors', 'secondary', 'gold-pale']
      },
      brick: {
        value: '#951c00',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#951c00',
          type: 'color'
        },
        name: 'ColorsSecondaryBrick',
        attributes: {
          category: 'colors',
          type: 'secondary',
          item: 'brick'
        },
        path: ['colors', 'secondary', 'brick']
      },
      taupe: {
        value: '#c1bbaf',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#c1bbaf',
          type: 'color'
        },
        name: 'ColorsSecondaryTaupe',
        attributes: {
          category: 'colors',
          type: 'secondary',
          item: 'taupe'
        },
        path: ['colors', 'secondary', 'taupe']
      },
      'taupe-light': {
        value: '#e4dbca',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#e4dbca',
          type: 'color'
        },
        name: 'ColorsSecondaryTaupeLight',
        attributes: {
          category: 'colors',
          type: 'secondary',
          item: 'taupe-light'
        },
        path: ['colors', 'secondary', 'taupe-light']
      }
    },
    tertiary: {
      storm: {
        value: '#1792b8',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#1792b8',
          type: 'color'
        },
        name: 'ColorsTertiaryStorm',
        attributes: {
          category: 'colors',
          type: 'tertiary',
          item: 'storm'
        },
        path: ['colors', 'tertiary', 'storm']
      },
      'storm-light': {
        value: '#5bbfd3',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#5bbfd3',
          type: 'color'
        },
        name: 'ColorsTertiaryStormLight',
        attributes: {
          category: 'colors',
          type: 'tertiary',
          item: 'storm-light'
        },
        path: ['colors', 'tertiary', 'storm-light']
      },
      pine: {
        value: '#4bab77',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#4bab77',
          type: 'color'
        },
        name: 'ColorsTertiaryPine',
        attributes: {
          category: 'colors',
          type: 'tertiary',
          item: 'pine'
        },
        path: ['colors', 'tertiary', 'pine']
      }
    },
    neutrals: {
      'grey-darker': {
        value: '#7e8489',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#7e8489',
          type: 'color'
        },
        name: 'ColorsNeutralsGreyDarker',
        attributes: {
          category: 'colors',
          type: 'neutrals',
          item: 'grey-darker'
        },
        path: ['colors', 'neutrals', 'grey-darker']
      },
      'grey-dark': {
        value: '#b7babc',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#b7babc',
          type: 'color'
        },
        name: 'ColorsNeutralsGreyDark',
        attributes: {
          category: 'colors',
          type: 'neutrals',
          item: 'grey-dark'
        },
        path: ['colors', 'neutrals', 'grey-dark']
      },
      grey: {
        value: '#dbdada',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#dbdada',
          type: 'color'
        },
        name: 'ColorsNeutralsGrey',
        attributes: {
          category: 'colors',
          type: 'neutrals',
          item: 'grey'
        },
        path: ['colors', 'neutrals', 'grey']
      },
      'grey-light': {
        value: '#ededed',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#ededed',
          type: 'color'
        },
        name: 'ColorsNeutralsGreyLight',
        attributes: {
          category: 'colors',
          type: 'neutrals',
          item: 'grey-light'
        },
        path: ['colors', 'neutrals', 'grey-light']
      },
      'grey-pale': {
        value: '#f5f5f5',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#f5f5f5',
          type: 'color'
        },
        name: 'ColorsNeutralsGreyPale',
        attributes: {
          category: 'colors',
          type: 'neutrals',
          item: 'grey-pale'
        },
        path: ['colors', 'neutrals', 'grey-pale']
      }
    }
  },
  fontFamilies: {
    fonts: {
      'font-1': {
        value: 'ff-real-headline-pro',
        type: 'fontFamilies',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: 'ff-real-headline-pro',
          type: 'fontFamilies'
        },
        name: 'FontFamiliesFontsFont1',
        attributes: {
          category: 'fontFamilies',
          type: 'fonts',
          item: 'font-1'
        },
        path: ['fontFamilies', 'fonts', 'font-1']
      },
      'font-2': {
        value: 'ff-real-headline-pro',
        type: 'fontFamilies',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: 'ff-real-headline-pro',
          type: 'fontFamilies'
        },
        name: 'FontFamiliesFontsFont2',
        attributes: {
          category: 'fontFamilies',
          type: 'fonts',
          item: 'font-2'
        },
        path: ['fontFamilies', 'fonts', 'font-2']
      },
      'font-3': {
        value: 'Georgia',
        type: 'fontFamilies',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: 'Georgia',
          type: 'fontFamilies'
        },
        name: 'FontFamiliesFontsFont3',
        attributes: {
          category: 'fontFamilies',
          type: 'fonts',
          item: 'font-3'
        },
        path: ['fontFamilies', 'fonts', 'font-3']
      }
    },
    uses: {
      'headline--font': {
        value: {
          value: 'ff-real-headline-pro',
          type: 'fontFamilies',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: 'ff-real-headline-pro',
            type: 'fontFamilies'
          },
          name: 'FontFamiliesFontsFont1',
          attributes: {
            category: 'fontFamilies',
            type: 'fonts',
            item: 'font-1'
          },
          path: ['fontFamilies', 'fonts', 'font-1']
        },
        type: 'fontFamilies',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontFamilies.fonts.font-1}',
          type: 'fontFamilies'
        },
        name: 'FontFamiliesUsesHeadlineFont',
        attributes: {
          category: 'fontFamilies',
          type: 'uses',
          item: 'headline--font'
        },
        path: ['fontFamilies', 'uses', 'headline--font']
      },
      'utility-text--font': {
        value: {
          value: 'ff-real-headline-pro',
          type: 'fontFamilies',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: 'ff-real-headline-pro',
            type: 'fontFamilies'
          },
          name: 'FontFamiliesFontsFont2',
          attributes: {
            category: 'fontFamilies',
            type: 'fonts',
            item: 'font-2'
          },
          path: ['fontFamilies', 'fonts', 'font-2']
        },
        type: 'fontFamilies',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontFamilies.fonts.font-2}',
          type: 'fontFamilies'
        },
        name: 'FontFamiliesUsesUtilityTextFont',
        attributes: {
          category: 'fontFamilies',
          type: 'uses',
          item: 'utility-text--font'
        },
        path: ['fontFamilies', 'uses', 'utility-text--font']
      },
      'paragraph-copy--font': {
        value: {
          value: 'ff-real-headline-pro',
          type: 'fontFamilies',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: 'ff-real-headline-pro',
            type: 'fontFamilies'
          },
          name: 'FontFamiliesFontsFont2',
          attributes: {
            category: 'fontFamilies',
            type: 'fonts',
            item: 'font-2'
          },
          path: ['fontFamilies', 'fonts', 'font-2']
        },
        type: 'fontFamilies',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontFamilies.fonts.font-2}',
          type: 'fontFamilies'
        },
        name: 'FontFamiliesUsesParagraphCopyFont',
        attributes: {
          category: 'fontFamilies',
          type: 'uses',
          item: 'paragraph-copy--font'
        },
        path: ['fontFamilies', 'uses', 'paragraph-copy--font']
      },
      'article-copy--font': {
        value: {
          value: 'Georgia',
          type: 'fontFamilies',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: 'Georgia',
            type: 'fontFamilies'
          },
          name: 'FontFamiliesFontsFont3',
          attributes: {
            category: 'fontFamilies',
            type: 'fonts',
            item: 'font-3'
          },
          path: ['fontFamilies', 'fonts', 'font-3']
        },
        type: 'fontFamilies',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontFamilies.fonts.font-3}',
          type: 'fontFamilies'
        },
        name: 'FontFamiliesUsesArticleCopyFont',
        attributes: {
          category: 'fontFamilies',
          type: 'uses',
          item: 'article-copy--font'
        },
        path: ['fontFamilies', 'uses', 'article-copy--font']
      }
    }
  },
  lineHeights: {
    shortest: {
      value: '130%',
      type: 'lineHeights',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '130%',
        type: 'lineHeights'
      },
      name: 'LineHeightsShortest',
      attributes: {
        category: 'lineHeights',
        type: 'shortest'
      },
      path: ['lineHeights', 'shortest']
    },
    short: {
      value: '135%',
      type: 'lineHeights',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '135%',
        type: 'lineHeights'
      },
      name: 'LineHeightsShort',
      attributes: {
        category: 'lineHeights',
        type: 'short'
      },
      path: ['lineHeights', 'short']
    },
    tall: {
      value: '140%',
      type: 'lineHeights',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '140%',
        type: 'lineHeights'
      },
      name: 'LineHeightsTall',
      attributes: {
        category: 'lineHeights',
        type: 'tall'
      },
      path: ['lineHeights', 'tall']
    },
    taller: {
      value: '150%',
      type: 'lineHeights',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '150%',
        type: 'lineHeights'
      },
      name: 'LineHeightsTaller',
      attributes: {
        category: 'lineHeights',
        type: 'taller'
      },
      path: ['lineHeights', 'taller']
    },
    tallest: {
      value: '160%',
      type: 'lineHeights',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '160%',
        type: 'lineHeights'
      },
      name: 'LineHeightsTallest',
      attributes: {
        category: 'lineHeights',
        type: 'tallest'
      },
      path: ['lineHeights', 'tallest']
    }
  },
  fontSizes: {
    12: {
      value: '12px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '12px',
        type: 'fontSizes'
      },
      name: 'FontSizes12',
      attributes: {
        category: 'fontSizes',
        type: '12'
      },
      path: ['fontSizes', '12']
    },
    13: {
      value: '13px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '13px',
        type: 'fontSizes'
      },
      name: 'FontSizes13',
      attributes: {
        category: 'fontSizes',
        type: '13'
      },
      path: ['fontSizes', '13']
    },
    14: {
      value: '14px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '14px',
        type: 'fontSizes'
      },
      name: 'FontSizes14',
      attributes: {
        category: 'fontSizes',
        type: '14'
      },
      path: ['fontSizes', '14']
    },
    15: {
      value: '15px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '15px',
        type: 'fontSizes'
      },
      name: 'FontSizes15',
      attributes: {
        category: 'fontSizes',
        type: '15'
      },
      path: ['fontSizes', '15']
    },
    16: {
      value: '16px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '16px',
        type: 'fontSizes'
      },
      name: 'FontSizes16',
      attributes: {
        category: 'fontSizes',
        type: '16'
      },
      path: ['fontSizes', '16']
    },
    17: {
      value: '17px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '17px',
        type: 'fontSizes'
      },
      name: 'FontSizes17',
      attributes: {
        category: 'fontSizes',
        type: '17'
      },
      path: ['fontSizes', '17']
    },
    18: {
      value: '18px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '18px',
        type: 'fontSizes'
      },
      name: 'FontSizes18',
      attributes: {
        category: 'fontSizes',
        type: '18'
      },
      path: ['fontSizes', '18']
    },
    20: {
      value: '20px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '20px',
        type: 'fontSizes'
      },
      name: 'FontSizes20',
      attributes: {
        category: 'fontSizes',
        type: '20'
      },
      path: ['fontSizes', '20']
    },
    22: {
      value: '22px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '22px',
        type: 'fontSizes'
      },
      name: 'FontSizes22',
      attributes: {
        category: 'fontSizes',
        type: '22'
      },
      path: ['fontSizes', '22']
    },
    24: {
      value: '24px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '24px',
        type: 'fontSizes'
      },
      name: 'FontSizes24',
      attributes: {
        category: 'fontSizes',
        type: '24'
      },
      path: ['fontSizes', '24']
    },
    26: {
      value: '26px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '26px',
        type: 'fontSizes'
      },
      name: 'FontSizes26',
      attributes: {
        category: 'fontSizes',
        type: '26'
      },
      path: ['fontSizes', '26']
    },
    30: {
      value: '30px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '30px',
        type: 'fontSizes'
      },
      name: 'FontSizes30',
      attributes: {
        category: 'fontSizes',
        type: '30'
      },
      path: ['fontSizes', '30']
    },
    32: {
      value: '32px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '32px',
        type: 'fontSizes'
      },
      name: 'FontSizes32',
      attributes: {
        category: 'fontSizes',
        type: '32'
      },
      path: ['fontSizes', '32']
    },
    36: {
      value: '36px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '36px',
        type: 'fontSizes'
      },
      name: 'FontSizes36',
      attributes: {
        category: 'fontSizes',
        type: '36'
      },
      path: ['fontSizes', '36']
    },
    40: {
      value: '40px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '40px',
        type: 'fontSizes'
      },
      name: 'FontSizes40',
      attributes: {
        category: 'fontSizes',
        type: '40'
      },
      path: ['fontSizes', '40']
    },
    42: {
      value: '42px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '42px',
        type: 'fontSizes'
      },
      name: 'FontSizes42',
      attributes: {
        category: 'fontSizes',
        type: '42'
      },
      path: ['fontSizes', '42']
    },
    50: {
      value: '50px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '50px',
        type: 'fontSizes'
      },
      name: 'FontSizes50',
      attributes: {
        category: 'fontSizes',
        type: '50'
      },
      path: ['fontSizes', '50']
    },
    60: {
      value: '60px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '60px',
        type: 'fontSizes'
      },
      name: 'FontSizes60',
      attributes: {
        category: 'fontSizes',
        type: '60'
      },
      path: ['fontSizes', '60']
    }
  },
  fontWeights: {
    weights: {
      200: {
        value: '200',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '200',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights200',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '200'
        },
        path: ['fontWeights', 'weights', '200']
      },
      300: {
        value: '300',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '300',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights300',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '300'
        },
        path: ['fontWeights', 'weights', '300']
      },
      400: {
        value: '400',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '400',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights400',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '400'
        },
        path: ['fontWeights', 'weights', '400']
      },
      500: {
        value: '500',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '500',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights500',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '500'
        },
        path: ['fontWeights', 'weights', '500']
      },
      600: {
        value: '600',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '600',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights600',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '600'
        },
        path: ['fontWeights', 'weights', '600']
      },
      700: {
        value: '700',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '700',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights700',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '700'
        },
        path: ['fontWeights', 'weights', '700']
      },
      800: {
        value: '800',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '800',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights800',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '800'
        },
        path: ['fontWeights', 'weights', '800']
      },
      900: {
        value: '900',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '900',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights900',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '900'
        },
        path: ['fontWeights', 'weights', '900']
      }
    },
    uses: {
      'headline--font-weight': {
        value: {
          value: '500',
          type: 'fontWeights',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: '500',
            type: 'fontWeights'
          },
          name: 'FontWeightsWeights500',
          attributes: {
            category: 'fontWeights',
            type: 'weights',
            item: '500'
          },
          path: ['fontWeights', 'weights', '500']
        },
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontWeights.weights.500}',
          type: 'fontWeights'
        },
        name: 'FontWeightsUsesHeadlineFontWeight',
        attributes: {
          category: 'fontWeights',
          type: 'uses',
          item: 'headline--font-weight'
        },
        path: ['fontWeights', 'uses', 'headline--font-weight']
      },
      'headline-xl--font-weight': {
        value: {
          value: '600',
          type: 'fontWeights',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: '600',
            type: 'fontWeights'
          },
          name: 'FontWeightsWeights600',
          attributes: {
            category: 'fontWeights',
            type: 'weights',
            item: '600'
          },
          path: ['fontWeights', 'weights', '600']
        },
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontWeights.weights.600}',
          type: 'fontWeights'
        },
        name: 'FontWeightsUsesHeadlineXlFontWeight',
        attributes: {
          category: 'fontWeights',
          type: 'uses',
          item: 'headline-xl--font-weight'
        },
        path: ['fontWeights', 'uses', 'headline-xl--font-weight']
      },
      'utility-text--font-weight': {
        value: {
          value: '400',
          type: 'fontWeights',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: '400',
            type: 'fontWeights'
          },
          name: 'FontWeightsWeights400',
          attributes: {
            category: 'fontWeights',
            type: 'weights',
            item: '400'
          },
          path: ['fontWeights', 'weights', '400']
        },
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontWeights.weights.400}',
          type: 'fontWeights'
        },
        name: 'FontWeightsUsesUtilityTextFontWeight',
        attributes: {
          category: 'fontWeights',
          type: 'uses',
          item: 'utility-text--font-weight'
        },
        path: ['fontWeights', 'uses', 'utility-text--font-weight']
      },
      'utility-text--uppercase--font-weight': {
        value: {
          value: '700',
          type: 'fontWeights',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: '700',
            type: 'fontWeights'
          },
          name: 'FontWeightsWeights700',
          attributes: {
            category: 'fontWeights',
            type: 'weights',
            item: '700'
          },
          path: ['fontWeights', 'weights', '700']
        },
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontWeights.weights.700}',
          type: 'fontWeights'
        },
        name: 'FontWeightsUsesUtilityTextUppercaseFontWeight',
        attributes: {
          category: 'fontWeights',
          type: 'uses',
          item: 'utility-text--uppercase--font-weight'
        },
        path: ['fontWeights', 'uses', 'utility-text--uppercase--font-weight']
      },
      'utility-text--uppercase-xl--font-weight': {
        value: {
          value: '400',
          type: 'fontWeights',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: '400',
            type: 'fontWeights'
          },
          name: 'FontWeightsWeights400',
          attributes: {
            category: 'fontWeights',
            type: 'weights',
            item: '400'
          },
          path: ['fontWeights', 'weights', '400']
        },
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontWeights.weights.400}',
          type: 'fontWeights'
        },
        name: 'FontWeightsUsesUtilityTextUppercaseXlFontWeight',
        attributes: {
          category: 'fontWeights',
          type: 'uses',
          item: 'utility-text--uppercase-xl--font-weight'
        },
        path: ['fontWeights', 'uses', 'utility-text--uppercase-xl--font-weight']
      },
      'paragraph-copy--font-weight': {
        value: {
          value: '400',
          type: 'fontWeights',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: '400',
            type: 'fontWeights'
          },
          name: 'FontWeightsWeights400',
          attributes: {
            category: 'fontWeights',
            type: 'weights',
            item: '400'
          },
          path: ['fontWeights', 'weights', '400']
        },
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontWeights.weights.400}',
          type: 'fontWeights'
        },
        name: 'FontWeightsUsesParagraphCopyFontWeight',
        attributes: {
          category: 'fontWeights',
          type: 'uses',
          item: 'paragraph-copy--font-weight'
        },
        path: ['fontWeights', 'uses', 'paragraph-copy--font-weight']
      },
      'article-copy--font-weight': {
        value: {
          value: '400',
          type: 'fontWeights',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: '400',
            type: 'fontWeights'
          },
          name: 'FontWeightsWeights400',
          attributes: {
            category: 'fontWeights',
            type: 'weights',
            item: '400'
          },
          path: ['fontWeights', 'weights', '400']
        },
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontWeights.weights.400}',
          type: 'fontWeights'
        },
        name: 'FontWeightsUsesArticleCopyFontWeight',
        attributes: {
          category: 'fontWeights',
          type: 'uses',
          item: 'article-copy--font-weight'
        },
        path: ['fontWeights', 'uses', 'article-copy--font-weight']
      }
    }
  },
  borderRadius: {
    rounded: {
      value: '300px',
      type: 'borderRadius',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '300px',
        type: 'borderRadius'
      },
      name: 'BorderRadiusRounded',
      attributes: {
        category: 'borderRadius',
        type: 'rounded'
      },
      path: ['borderRadius', 'rounded']
    },
    default: {
      value: '4px',
      type: 'borderRadius',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '4px',
        type: 'borderRadius'
      },
      name: 'BorderRadiusDefault',
      attributes: {
        category: 'borderRadius',
        type: 'default'
      },
      path: ['borderRadius', 'default']
    },
    square: {
      value: '0px',
      type: 'borderRadius',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '0px',
        type: 'borderRadius'
      },
      name: 'BorderRadiusSquare',
      attributes: {
        category: 'borderRadius',
        type: 'square'
      },
      path: ['borderRadius', 'square']
    }
  },
  letterSpacing: {
    normal: {
      value: '0',
      type: 'letterSpacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '0',
        type: 'letterSpacing'
      },
      name: 'LetterSpacingNormal',
      attributes: {
        category: 'letterSpacing',
        type: 'normal'
      },
      path: ['letterSpacing', 'normal']
    },
    wide: {
      value: '.03em',
      type: 'letterSpacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '.03em',
        type: 'letterSpacing'
      },
      name: 'LetterSpacingWide',
      attributes: {
        category: 'letterSpacing',
        type: 'wide'
      },
      path: ['letterSpacing', 'wide']
    },
    'wide-x': {
      value: '.05em',
      type: 'letterSpacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '.05em',
        type: 'letterSpacing'
      },
      name: 'LetterSpacingWideX',
      attributes: {
        category: 'letterSpacing',
        type: 'wide-x'
      },
      path: ['letterSpacing', 'wide-x']
    },
    'wide-xx': {
      value: '.175em',
      type: 'letterSpacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '.175em',
        type: 'letterSpacing'
      },
      name: 'LetterSpacingWideXx',
      attributes: {
        category: 'letterSpacing',
        type: 'wide-xx'
      },
      path: ['letterSpacing', 'wide-xx']
    },
    'wide-xxx': {
      value: '.25em',
      type: 'letterSpacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '.25em',
        type: 'letterSpacing'
      },
      name: 'LetterSpacingWideXxx',
      attributes: {
        category: 'letterSpacing',
        type: 'wide-xxx'
      },
      path: ['letterSpacing', 'wide-xxx']
    }
  },
  typography: {
    mobile: {
      headlines: {
        h6: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '16px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '16px',
                type: 'fontSizes'
              },
              name: 'FontSizes16',
              attributes: {
                category: 'fontSizes',
                type: '16'
              },
              path: ['fontSizes', '16']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.16}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h6',
          attributes: {},
          path: ['typography', 'mobile', 'headlines', 'h6']
        },
        h5: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '18px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '18px',
                type: 'fontSizes'
              },
              name: 'FontSizes18',
              attributes: {
                category: 'fontSizes',
                type: '18'
              },
              path: ['fontSizes', '18']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.18}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h5',
          attributes: {},
          path: ['typography', 'mobile', 'headlines', 'h5']
        },
        h4: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '20px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '20px',
                type: 'fontSizes'
              },
              name: 'FontSizes20',
              attributes: {
                category: 'fontSizes',
                type: '20'
              },
              path: ['fontSizes', '20']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.20}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h4',
          attributes: {},
          path: ['typography', 'mobile', 'headlines', 'h4']
        },
        h3: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '22px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '22px',
                type: 'fontSizes'
              },
              name: 'FontSizes22',
              attributes: {
                category: 'fontSizes',
                type: '22'
              },
              path: ['fontSizes', '22']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.22}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h3',
          attributes: {},
          path: ['typography', 'mobile', 'headlines', 'h3']
        },
        h2: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '26px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '26px',
                type: 'fontSizes'
              },
              name: 'FontSizes26',
              attributes: {
                category: 'fontSizes',
                type: '26'
              },
              path: ['fontSizes', '26']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.26}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h2',
          attributes: {},
          path: ['typography', 'mobile', 'headlines', 'h2']
        },
        h1: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '30px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '30px',
                type: 'fontSizes'
              },
              name: 'FontSizes30',
              attributes: {
                category: 'fontSizes',
                type: '30'
              },
              path: ['fontSizes', '30']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.30}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h1',
          attributes: {},
          path: ['typography', 'mobile', 'headlines', 'h1']
        },
        xl: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '600',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '600',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights600',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '600'
                },
                path: ['fontWeights', 'weights', '600']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.600}',
                type: 'fontWeights'
              },
              name: 'headline-xl--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline-xl--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '40px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '40px',
                type: 'fontSizes'
              },
              name: 'FontSizes40',
              attributes: {
                category: 'fontSizes',
                type: '40'
              },
              path: ['fontSizes', '40']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline-xl--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.40}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'xl',
          attributes: {},
          path: ['typography', 'mobile', 'headlines', 'xl']
        }
      },
      'utility-text': {
        small: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'utility-text--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'utility-text--font-weight']
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '12px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '12px',
                type: 'fontSizes'
              },
              name: 'FontSizes12',
              attributes: {
                category: 'fontSizes',
                type: '12'
              },
              path: ['fontSizes', '12']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight: '{fontWeights.uses.utility-text--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.12}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'small',
          attributes: {},
          path: ['typography', 'mobile', 'utility-text', 'small']
        },
        large: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'utility-text--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'utility-text--font-weight']
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '15px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '15px',
                type: 'fontSizes'
              },
              name: 'FontSizes15',
              attributes: {
                category: 'fontSizes',
                type: '15'
              },
              path: ['fontSizes', '15']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight: '{fontWeights.uses.utility-text--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.15}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'large',
          attributes: {},
          path: ['typography', 'mobile', 'utility-text', 'large']
        },
        'uppercase--small': {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '700',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '700',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights700',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '700'
                },
                path: ['fontWeights', 'weights', '700']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.700}',
                type: 'fontWeights'
              },
              name: 'utility-text--uppercase--font-weight',
              attributes: {},
              path: [
                'fontWeights',
                'uses',
                'utility-text--uppercase--font-weight'
              ]
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '12px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '12px',
                type: 'fontSizes'
              },
              name: 'FontSizes12',
              attributes: {
                category: 'fontSizes',
                type: '12'
              },
              path: ['fontSizes', '12']
            },
            letterSpacing: {
              value: '.175em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.175em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWideXx',
              attributes: {
                category: 'letterSpacing',
                type: 'wide-xx'
              },
              path: ['letterSpacing', 'wide-xx']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight:
                '{fontWeights.uses.utility-text--uppercase--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.12}',
              letterSpacing: '{letterSpacing.wide-xx}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'uppercase--small',
          attributes: {},
          path: ['typography', 'mobile', 'utility-text', 'uppercase--small']
        },
        'uppercase--large': {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '700',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '700',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights700',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '700'
                },
                path: ['fontWeights', 'weights', '700']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.700}',
                type: 'fontWeights'
              },
              name: 'utility-text--uppercase--font-weight',
              attributes: {},
              path: [
                'fontWeights',
                'uses',
                'utility-text--uppercase--font-weight'
              ]
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '14px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '14px',
                type: 'fontSizes'
              },
              name: 'FontSizes14',
              attributes: {
                category: 'fontSizes',
                type: '14'
              },
              path: ['fontSizes', '14']
            },
            letterSpacing: {
              value: '.175em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.175em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWideXx',
              attributes: {
                category: 'letterSpacing',
                type: 'wide-xx'
              },
              path: ['letterSpacing', 'wide-xx']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight:
                '{fontWeights.uses.utility-text--uppercase--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.14}',
              letterSpacing: '{letterSpacing.wide-xx}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'uppercase--large',
          attributes: {},
          path: ['typography', 'mobile', 'utility-text', 'uppercase--large']
        },
        'uppercase--xl': {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'utility-text--uppercase-xl--font-weight',
              attributes: {},
              path: [
                'fontWeights',
                'uses',
                'utility-text--uppercase-xl--font-weight'
              ]
            },
            lineHeight: {
              value: '140%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '140%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTall',
              attributes: {
                category: 'lineHeights',
                type: 'tall'
              },
              path: ['lineHeights', 'tall']
            },
            fontSize: {
              value: '20px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '20px',
                type: 'fontSizes'
              },
              name: 'FontSizes20',
              attributes: {
                category: 'fontSizes',
                type: '20'
              },
              path: ['fontSizes', '20']
            },
            letterSpacing: {
              value: '.25em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.25em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWideXxx',
              attributes: {
                category: 'letterSpacing',
                type: 'wide-xxx'
              },
              path: ['letterSpacing', 'wide-xxx']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight:
                '{fontWeights.uses.utility-text--uppercase-xl--font-weight}',
              lineHeight: '{lineHeights.tall}',
              fontSize: '{fontSizes.20}',
              letterSpacing: '{letterSpacing.wide-xxx}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'uppercase--xl',
          attributes: {},
          path: ['typography', 'mobile', 'utility-text', 'uppercase--xl']
        }
      },
      'paragraph-copy': {
        small: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'paragraph-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'paragraph-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'paragraph-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'paragraph-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '13px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '13px',
                type: 'fontSizes'
              },
              name: 'FontSizes13',
              attributes: {
                category: 'fontSizes',
                type: '13'
              },
              path: ['fontSizes', '13']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.paragraph-copy--font}',
              fontWeight: '{fontWeights.uses.paragraph-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.13}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'small',
          attributes: {},
          path: ['typography', 'mobile', 'paragraph-copy', 'small']
        },
        standard: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'paragraph-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'paragraph-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'paragraph-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'paragraph-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '15px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '15px',
                type: 'fontSizes'
              },
              name: 'FontSizes15',
              attributes: {
                category: 'fontSizes',
                type: '15'
              },
              path: ['fontSizes', '15']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.paragraph-copy--font}',
              fontWeight: '{fontWeights.uses.paragraph-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.15}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'standard',
          attributes: {},
          path: ['typography', 'mobile', 'paragraph-copy', 'standard']
        }
      },
      'article-copy': {
        small: {
          value: {
            fontFamily: {
              value: {
                value: 'Georgia',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'Georgia',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont3',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-3'
                },
                path: ['fontFamilies', 'fonts', 'font-3']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-3}',
                type: 'fontFamilies'
              },
              name: 'article-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'article-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'article-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'article-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '15px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '15px',
                type: 'fontSizes'
              },
              name: 'FontSizes15',
              attributes: {
                category: 'fontSizes',
                type: '15'
              },
              path: ['fontSizes', '15']
            },
            letterSpacing: {
              value: '0',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingNormal',
              attributes: {
                category: 'letterSpacing',
                type: 'normal'
              },
              path: ['letterSpacing', 'normal']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.article-copy--font}',
              fontWeight: '{fontWeights.uses.article-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.15}',
              letterSpacing: '{letterSpacing.normal}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'small',
          attributes: {},
          path: ['typography', 'mobile', 'article-copy', 'small']
        },
        standard: {
          value: {
            fontFamily: {
              value: {
                value: 'Georgia',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'Georgia',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont3',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-3'
                },
                path: ['fontFamilies', 'fonts', 'font-3']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-3}',
                type: 'fontFamilies'
              },
              name: 'article-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'article-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'article-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'article-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '17px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '17px',
                type: 'fontSizes'
              },
              name: 'FontSizes17',
              attributes: {
                category: 'fontSizes',
                type: '17'
              },
              path: ['fontSizes', '17']
            },
            letterSpacing: {
              value: '0',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingNormal',
              attributes: {
                category: 'letterSpacing',
                type: 'normal'
              },
              path: ['letterSpacing', 'normal']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.article-copy--font}',
              fontWeight: '{fontWeights.uses.article-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.17}',
              letterSpacing: '{letterSpacing.normal}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'standard',
          attributes: {},
          path: ['typography', 'mobile', 'article-copy', 'standard']
        },
        'large-oblique': {
          value: {
            fontFamily: {
              value: {
                value: 'Georgia',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'Georgia',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont3',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-3'
                },
                path: ['fontFamilies', 'fonts', 'font-3']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-3}',
                type: 'fontFamilies'
              },
              name: 'article-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'article-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'article-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'article-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '18px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '18px',
                type: 'fontSizes'
              },
              name: 'FontSizes18',
              attributes: {
                category: 'fontSizes',
                type: '18'
              },
              path: ['fontSizes', '18']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.article-copy--font}',
              fontWeight: '{fontWeights.uses.article-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.18}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'large-oblique',
          attributes: {},
          path: ['typography', 'mobile', 'article-copy', 'large-oblique']
        }
      }
    },
    tablet: {
      headlines: {
        h6: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '16px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '16px',
                type: 'fontSizes'
              },
              name: 'FontSizes16',
              attributes: {
                category: 'fontSizes',
                type: '16'
              },
              path: ['fontSizes', '16']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.16}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h6',
          attributes: {},
          path: ['typography', 'tablet', 'headlines', 'h6']
        },
        h5: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '18px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '18px',
                type: 'fontSizes'
              },
              name: 'FontSizes18',
              attributes: {
                category: 'fontSizes',
                type: '18'
              },
              path: ['fontSizes', '18']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.18}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h5',
          attributes: {},
          path: ['typography', 'tablet', 'headlines', 'h5']
        },
        h4: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '22px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '22px',
                type: 'fontSizes'
              },
              name: 'FontSizes22',
              attributes: {
                category: 'fontSizes',
                type: '22'
              },
              path: ['fontSizes', '22']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.22}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h4',
          attributes: {},
          path: ['typography', 'tablet', 'headlines', 'h4']
        },
        h3: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '24px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '24px',
                type: 'fontSizes'
              },
              name: 'FontSizes24',
              attributes: {
                category: 'fontSizes',
                type: '24'
              },
              path: ['fontSizes', '24']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.24}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h3',
          attributes: {},
          path: ['typography', 'tablet', 'headlines', 'h3']
        },
        h2: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '30px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '30px',
                type: 'fontSizes'
              },
              name: 'FontSizes30',
              attributes: {
                category: 'fontSizes',
                type: '30'
              },
              path: ['fontSizes', '30']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.30}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h2',
          attributes: {},
          path: ['typography', 'tablet', 'headlines', 'h2']
        },
        h1: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '36px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '36px',
                type: 'fontSizes'
              },
              name: 'FontSizes36',
              attributes: {
                category: 'fontSizes',
                type: '36'
              },
              path: ['fontSizes', '36']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.36}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h1',
          attributes: {},
          path: ['typography', 'tablet', 'headlines', 'h1']
        },
        xl: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '600',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '600',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights600',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '600'
                },
                path: ['fontWeights', 'weights', '600']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.600}',
                type: 'fontWeights'
              },
              name: 'headline-xl--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline-xl--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '50px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '50px',
                type: 'fontSizes'
              },
              name: 'FontSizes50',
              attributes: {
                category: 'fontSizes',
                type: '50'
              },
              path: ['fontSizes', '50']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline-xl--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.50}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'xl',
          attributes: {},
          path: ['typography', 'tablet', 'headlines', 'xl']
        }
      }
    },
    desktop: {
      headlines: {
        h6: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '18px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '18px',
                type: 'fontSizes'
              },
              name: 'FontSizes18',
              attributes: {
                category: 'fontSizes',
                type: '18'
              },
              path: ['fontSizes', '18']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.18}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h6',
          attributes: {},
          path: ['typography', 'desktop', 'headlines', 'h6']
        },
        h5: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '20px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '20px',
                type: 'fontSizes'
              },
              name: 'FontSizes20',
              attributes: {
                category: 'fontSizes',
                type: '20'
              },
              path: ['fontSizes', '20']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.20}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h5',
          attributes: {},
          path: ['typography', 'desktop', 'headlines', 'h5']
        },
        h4: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '22px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '22px',
                type: 'fontSizes'
              },
              name: 'FontSizes22',
              attributes: {
                category: 'fontSizes',
                type: '22'
              },
              path: ['fontSizes', '22']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.22}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h4',
          attributes: {},
          path: ['typography', 'desktop', 'headlines', 'h4']
        },
        h3: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '26px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '26px',
                type: 'fontSizes'
              },
              name: 'FontSizes26',
              attributes: {
                category: 'fontSizes',
                type: '26'
              },
              path: ['fontSizes', '26']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.26}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h3',
          attributes: {},
          path: ['typography', 'desktop', 'headlines', 'h3']
        },
        h2: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '32px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '32px',
                type: 'fontSizes'
              },
              name: 'FontSizes32',
              attributes: {
                category: 'fontSizes',
                type: '32'
              },
              path: ['fontSizes', '32']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.32}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h2',
          attributes: {},
          path: ['typography', 'desktop', 'headlines', 'h2']
        },
        h1: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '42px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '42px',
                type: 'fontSizes'
              },
              name: 'FontSizes42',
              attributes: {
                category: 'fontSizes',
                type: '42'
              },
              path: ['fontSizes', '42']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.42}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h1',
          attributes: {},
          path: ['typography', 'desktop', 'headlines', 'h1']
        },
        xl: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '600',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '600',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights600',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '600'
                },
                path: ['fontWeights', 'weights', '600']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.600}',
                type: 'fontWeights'
              },
              name: 'headline-xl--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline-xl--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '60px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '60px',
                type: 'fontSizes'
              },
              name: 'FontSizes60',
              attributes: {
                category: 'fontSizes',
                type: '60'
              },
              path: ['fontSizes', '60']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline-xl--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.60}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'xl',
          attributes: {},
          path: ['typography', 'desktop', 'headlines', 'xl']
        }
      },
      'utility-text': {
        small: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'utility-text--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'utility-text--font-weight']
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '13px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '13px',
                type: 'fontSizes'
              },
              name: 'FontSizes13',
              attributes: {
                category: 'fontSizes',
                type: '13'
              },
              path: ['fontSizes', '13']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight: '{fontWeights.uses.utility-text--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.13}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'small',
          attributes: {},
          path: ['typography', 'desktop', 'utility-text', 'small']
        },
        large: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'utility-text--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'utility-text--font-weight']
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '16px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '16px',
                type: 'fontSizes'
              },
              name: 'FontSizes16',
              attributes: {
                category: 'fontSizes',
                type: '16'
              },
              path: ['fontSizes', '16']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight: '{fontWeights.uses.utility-text--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.16}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'large',
          attributes: {},
          path: ['typography', 'desktop', 'utility-text', 'large']
        },
        'uppercase--small': {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '700',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '700',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights700',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '700'
                },
                path: ['fontWeights', 'weights', '700']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.700}',
                type: 'fontWeights'
              },
              name: 'utility-text--uppercase--font-weight',
              attributes: {},
              path: [
                'fontWeights',
                'uses',
                'utility-text--uppercase--font-weight'
              ]
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '14px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '14px',
                type: 'fontSizes'
              },
              name: 'FontSizes14',
              attributes: {
                category: 'fontSizes',
                type: '14'
              },
              path: ['fontSizes', '14']
            },
            letterSpacing: {
              value: '.175em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.175em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWideXx',
              attributes: {
                category: 'letterSpacing',
                type: 'wide-xx'
              },
              path: ['letterSpacing', 'wide-xx']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight:
                '{fontWeights.uses.utility-text--uppercase--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.14}',
              letterSpacing: '{letterSpacing.wide-xx}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'uppercase--small',
          attributes: {},
          path: ['typography', 'desktop', 'utility-text', 'uppercase--small']
        },
        'uppercase--large': {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '700',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '700',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights700',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '700'
                },
                path: ['fontWeights', 'weights', '700']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.700}',
                type: 'fontWeights'
              },
              name: 'utility-text--uppercase--font-weight',
              attributes: {},
              path: [
                'fontWeights',
                'uses',
                'utility-text--uppercase--font-weight'
              ]
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '16px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '16px',
                type: 'fontSizes'
              },
              name: 'FontSizes16',
              attributes: {
                category: 'fontSizes',
                type: '16'
              },
              path: ['fontSizes', '16']
            },
            letterSpacing: {
              value: '.175em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.175em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWideXx',
              attributes: {
                category: 'letterSpacing',
                type: 'wide-xx'
              },
              path: ['letterSpacing', 'wide-xx']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight:
                '{fontWeights.uses.utility-text--uppercase--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.16}',
              letterSpacing: '{letterSpacing.wide-xx}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'uppercase--large',
          attributes: {},
          path: ['typography', 'desktop', 'utility-text', 'uppercase--large']
        },
        'uppercase--xl': {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'utility-text--uppercase-xl--font-weight',
              attributes: {},
              path: [
                'fontWeights',
                'uses',
                'utility-text--uppercase-xl--font-weight'
              ]
            },
            lineHeight: {
              value: '140%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '140%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTall',
              attributes: {
                category: 'lineHeights',
                type: 'tall'
              },
              path: ['lineHeights', 'tall']
            },
            fontSize: {
              value: '26px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '26px',
                type: 'fontSizes'
              },
              name: 'FontSizes26',
              attributes: {
                category: 'fontSizes',
                type: '26'
              },
              path: ['fontSizes', '26']
            },
            letterSpacing: {
              value: '.25em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.25em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWideXxx',
              attributes: {
                category: 'letterSpacing',
                type: 'wide-xxx'
              },
              path: ['letterSpacing', 'wide-xxx']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight:
                '{fontWeights.uses.utility-text--uppercase-xl--font-weight}',
              lineHeight: '{lineHeights.tall}',
              fontSize: '{fontSizes.26}',
              letterSpacing: '{letterSpacing.wide-xxx}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'uppercase--xl',
          attributes: {},
          path: ['typography', 'desktop', 'utility-text', 'uppercase--xl']
        }
      },
      'paragraph-styles': {
        small: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'paragraph-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'paragraph-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'paragraph-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'paragraph-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '14px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '14px',
                type: 'fontSizes'
              },
              name: 'FontSizes14',
              attributes: {
                category: 'fontSizes',
                type: '14'
              },
              path: ['fontSizes', '14']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.paragraph-copy--font}',
              fontWeight: '{fontWeights.uses.paragraph-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.14}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'small',
          attributes: {},
          path: ['typography', 'desktop', 'paragraph-styles', 'small']
        },
        standard: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'paragraph-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'paragraph-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'paragraph-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'paragraph-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '16px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '16px',
                type: 'fontSizes'
              },
              name: 'FontSizes16',
              attributes: {
                category: 'fontSizes',
                type: '16'
              },
              path: ['fontSizes', '16']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.paragraph-copy--font}',
              fontWeight: '{fontWeights.uses.paragraph-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.16}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'standard',
          attributes: {},
          path: ['typography', 'desktop', 'paragraph-styles', 'standard']
        }
      },
      'article-copy': {
        small: {
          value: {
            fontFamily: {
              value: {
                value: 'Georgia',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'Georgia',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont3',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-3'
                },
                path: ['fontFamilies', 'fonts', 'font-3']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-3}',
                type: 'fontFamilies'
              },
              name: 'article-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'article-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'article-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'article-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '16px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '16px',
                type: 'fontSizes'
              },
              name: 'FontSizes16',
              attributes: {
                category: 'fontSizes',
                type: '16'
              },
              path: ['fontSizes', '16']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.article-copy--font}',
              fontWeight: '{fontWeights.uses.article-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.16}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'small',
          attributes: {},
          path: ['typography', 'desktop', 'article-copy', 'small']
        },
        standard: {
          value: {
            fontFamily: {
              value: {
                value: 'Georgia',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'Georgia',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont3',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-3'
                },
                path: ['fontFamilies', 'fonts', 'font-3']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-3}',
                type: 'fontFamilies'
              },
              name: 'article-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'article-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'article-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'article-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '18px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '18px',
                type: 'fontSizes'
              },
              name: 'FontSizes18',
              attributes: {
                category: 'fontSizes',
                type: '18'
              },
              path: ['fontSizes', '18']
            },
            letterSpacing: {
              value: '0',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingNormal',
              attributes: {
                category: 'letterSpacing',
                type: 'normal'
              },
              path: ['letterSpacing', 'normal']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.article-copy--font}',
              fontWeight: '{fontWeights.uses.article-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.18}',
              letterSpacing: '{letterSpacing.normal}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'standard',
          attributes: {},
          path: ['typography', 'desktop', 'article-copy', 'standard']
        },
        'large-oblique': {
          value: {
            fontFamily: {
              value: {
                value: 'Georgia',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'Georgia',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont3',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-3'
                },
                path: ['fontFamilies', 'fonts', 'font-3']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-3}',
                type: 'fontFamilies'
              },
              name: 'article-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'article-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'article-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'article-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '20px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '20px',
                type: 'fontSizes'
              },
              name: 'FontSizes20',
              attributes: {
                category: 'fontSizes',
                type: '20'
              },
              path: ['fontSizes', '20']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.article-copy--font}',
              fontWeight: '{fontWeights.uses.article-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.20}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'large-oblique',
          attributes: {},
          path: ['typography', 'desktop', 'article-copy', 'large-oblique']
        }
      }
    }
  },
  paragraphSpacing: {
    normal: {
      value: '0',
      type: 'paragraphSpacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '0',
        type: 'paragraphSpacing'
      },
      name: 'ParagraphSpacingNormal',
      attributes: {
        category: 'paragraphSpacing',
        type: 'normal'
      },
      path: ['paragraphSpacing', 'normal']
    }
  },
  boxShadow: {
    none: {
      value: {
        x: '0',
        y: '0',
        spread: '0',
        color: 'rgba(0, 0, 0, 0,)',
        blur: '0'
      },
      type: 'boxShadow',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: {
          x: '0',
          y: '0',
          spread: '0',
          color: 'rgba(0, 0, 0, 0,)',
          blur: '0'
        },
        type: 'boxShadow'
      },
      name: 'BoxShadowNone',
      attributes: {
        category: 'boxShadow',
        type: 'none'
      },
      path: ['boxShadow', 'none']
    },
    default: {
      value: {
        x: '0',
        y: '1',
        spread: '0',
        color: 'rgba(0, 0, 0, .25)',
        blur: '3'
      },
      type: 'boxShadow',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: {
          x: '0',
          y: '1',
          spread: '0',
          color: 'rgba(0, 0, 0, .25)',
          blur: '3'
        },
        type: 'boxShadow'
      },
      name: 'BoxShadowDefault',
      attributes: {
        category: 'boxShadow',
        type: 'default'
      },
      path: ['boxShadow', 'default']
    },
    large: {
      value: {
        x: '0',
        y: '3',
        spread: '0',
        color: 'rgba(0, 0, 0, .2)',
        blur: '6'
      },
      type: 'boxShadow',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: {
          x: '0',
          y: '3',
          spread: '0',
          color: 'rgba(0, 0, 0, .2)',
          blur: '6'
        },
        type: 'boxShadow'
      },
      name: 'BoxShadowLarge',
      attributes: {
        category: 'boxShadow',
        type: 'large'
      },
      path: ['boxShadow', 'large']
    },
    'large-x': {
      value: {
        x: '0',
        y: '6',
        spread: '0',
        color: 'rgba(0, 0, 0,.2)',
        blur: '12'
      },
      type: 'boxShadow',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: {
          x: '0',
          y: '6',
          spread: '0',
          color: 'rgba(0, 0, 0,.2)',
          blur: '12'
        },
        type: 'boxShadow'
      },
      name: 'BoxShadowLargeX',
      attributes: {
        category: 'boxShadow',
        type: 'large-x'
      },
      path: ['boxShadow', 'large-x']
    }
  },
  borderWidth: {
    0: {
      value: '0px',
      type: 'borderWidth',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '0px',
        type: 'borderWidth'
      },
      name: 'BorderWidth0',
      attributes: {
        category: 'borderWidth',
        type: '0'
      },
      path: ['borderWidth', '0']
    },
    1: {
      value: '1px',
      type: 'borderWidth',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '1px',
        type: 'borderWidth'
      },
      name: 'BorderWidth1',
      attributes: {
        category: 'borderWidth',
        type: '1'
      },
      path: ['borderWidth', '1']
    },
    2: {
      value: '2px',
      type: 'borderWidth',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '2px',
        type: 'borderWidth'
      },
      name: 'BorderWidth2',
      attributes: {
        category: 'borderWidth',
        type: '2'
      },
      path: ['borderWidth', '2']
    },
    4: {
      value: '4px',
      type: 'borderWidth',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '4px',
        type: 'borderWidth'
      },
      name: 'BorderWidth4',
      attributes: {
        category: 'borderWidth',
        type: '4'
      },
      path: ['borderWidth', '4']
    },
    8: {
      value: '8px',
      type: 'borderWidth',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '8px',
        type: 'borderWidth'
      },
      name: 'BorderWidth8',
      attributes: {
        category: 'borderWidth',
        type: '8'
      },
      path: ['borderWidth', '8']
    }
  },
  backgroundPosition: {
    top: {
      value: 'top',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'top',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionTop',
      attributes: {
        category: 'backgroundPosition',
        type: 'top'
      },
      path: ['backgroundPosition', 'top']
    },
    left: {
      value: 'left',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'left',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionLeft',
      attributes: {
        category: 'backgroundPosition',
        type: 'left'
      },
      path: ['backgroundPosition', 'left']
    },
    bottom: {
      value: 'bottom',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'bottom',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionBottom',
      attributes: {
        category: 'backgroundPosition',
        type: 'bottom'
      },
      path: ['backgroundPosition', 'bottom']
    },
    right: {
      value: 'right',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'right',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionRight',
      attributes: {
        category: 'backgroundPosition',
        type: 'right'
      },
      path: ['backgroundPosition', 'right']
    },
    'left-top': {
      value: 'left top',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'left top',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionLeftTop',
      attributes: {
        category: 'backgroundPosition',
        type: 'left-top'
      },
      path: ['backgroundPosition', 'left-top']
    },
    'left-bottom': {
      value: 'left bottom',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'left bottom',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionLeftBottom',
      attributes: {
        category: 'backgroundPosition',
        type: 'left-bottom'
      },
      path: ['backgroundPosition', 'left-bottom']
    },
    'right-top': {
      value: 'right top',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'right top',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionRightTop',
      attributes: {
        category: 'backgroundPosition',
        type: 'right-top'
      },
      path: ['backgroundPosition', 'right-top']
    },
    'right-bottom': {
      value: 'right bottom',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'right bottom',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionRightBottom',
      attributes: {
        category: 'backgroundPosition',
        type: 'right-bottom'
      },
      path: ['backgroundPosition', 'right-bottom']
    }
  },
  breakpoints: {
    'narrow-xxx': {
      value: '480px',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '480px',
        type: 'breakpoint'
      },
      name: 'BreakpointsNarrowXxx',
      attributes: {
        category: 'breakpoints',
        type: 'narrow-xxx'
      },
      path: ['breakpoints', 'narrow-xxx']
    },
    'narrow-xx': {
      value: '640px',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '640px',
        type: 'breakpoint'
      },
      name: 'BreakpointsNarrowXx',
      attributes: {
        category: 'breakpoints',
        type: 'narrow-xx'
      },
      path: ['breakpoints', 'narrow-xx']
    },
    'narrow-x': {
      value: '767px',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '767px',
        type: 'breakpoint'
      },
      name: 'BreakpointsNarrowX',
      attributes: {
        category: 'breakpoints',
        type: 'narrow-x'
      },
      path: ['breakpoints', 'narrow-x']
    },
    narrow: {
      value: '1024px',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '1024px',
        type: 'breakpoint'
      },
      name: 'BreakpointsNarrow',
      attributes: {
        category: 'breakpoints',
        type: 'narrow'
      },
      path: ['breakpoints', 'narrow']
    },
    wide: {
      value: '1280px',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '1280px',
        type: 'breakpoint'
      },
      name: 'BreakpointsWide',
      attributes: {
        category: 'breakpoints',
        type: 'wide'
      },
      path: ['breakpoints', 'wide']
    },
    'wide-x': {
      value: '1440px',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '1440px',
        type: 'breakpoint'
      },
      name: 'BreakpointsWideX',
      attributes: {
        category: 'breakpoints',
        type: 'wide-x'
      },
      path: ['breakpoints', 'wide-x']
    },
    'wide-xx': {
      value: '1640',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '1640',
        type: 'breakpoint'
      },
      name: 'BreakpointsWideXx',
      attributes: {
        category: 'breakpoints',
        type: 'wide-xx'
      },
      path: ['breakpoints', 'wide-xx']
    },
    'wide-xxx': {
      value: '1750',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '1750',
        type: 'breakpoint'
      },
      name: 'BreakpointsWideXxx',
      attributes: {
        category: 'breakpoints',
        type: 'wide-xxx'
      },
      path: ['breakpoints', 'wide-xxx']
    }
  },
  space: {
    'padding-base': {
      value: '4px',
      type: 'spacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '4px',
        type: 'spacing'
      },
      name: 'SpacePaddingBase',
      attributes: {
        category: 'space',
        type: 'padding-base'
      },
      path: ['space', 'padding-base']
    },
    'margin-base': {
      value: '4px',
      type: 'spacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '4px',
        type: 'spacing'
      },
      name: 'SpaceMarginBase',
      attributes: {
        category: 'space',
        type: 'margin-base'
      },
      path: ['space', 'margin-base']
    }
  },
  grid: {
    'column-count': {
      value: '12',
      type: 'grid',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '12',
        type: 'grid'
      },
      name: 'GridColumnCount',
      attributes: {
        category: 'grid',
        type: 'column-count'
      },
      path: ['grid', 'column-count']
    },
    'column-gap-base': {
      value: '24px',
      type: 'grid',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '24px',
        type: 'grid'
      },
      name: 'GridColumnGapBase',
      attributes: {
        category: 'grid',
        type: 'column-gap-base'
      },
      path: ['grid', 'column-gap-base']
    }
  }
};
